export const plCase01Messages = {
  "intro-page.case01.title": `O Wozie ATMOS`,
  "intro-page.case01.navbarTitle": `Transmisje na żywo z Wozu ATMOS`,
};
